import { useMemo } from 'react';

import SearchSuggestionRow from '@/components/SearchSuggestionRow';
import SearchSuggestionRowSkeleton from '@/components/SearchSuggestionRowSkeleton';
import useCategoryLabel from '@/hooks/useCategoryLabel';
import { SEARCH_SKELETON_COUNT } from '@/consts/search';

import useStyles from './styles';
import type { SearchResultsProps } from './types';

/**
 * The desktop dropdown's result list. While loading it renders the same number
 * of placeholder rows, so the popover opens at its final size instead of
 * growing under the cursor when results land.
 */
const SearchResults = ({
  items,
  isLoading,
  onItemClick,
}: SearchResultsProps) => {
  const classes = useStyles();
  const getCategoryLabel = useCategoryLabel();

  const skeletonKeys = useMemo(
    () =>
      Array.from(
        { length: SEARCH_SKELETON_COUNT },
        (_, index) => `search-row-skeleton-${index}`
      ),
    []
  );

  if (isLoading) {
    return (
      <ul className={classes.list} data-testid="search-results-skeleton">
        {skeletonKeys.map((key) => (
          <li key={key}>
            <SearchSuggestionRowSkeleton />
          </li>
        ))}
      </ul>
    );
  }

  return (
    <ul className={classes.list} data-testid="search-results">
      {items.map((item) => (
        <li key={item.id}>
          <SearchSuggestionRow
            item={item}
            categoryLabel={getCategoryLabel(item.categorySlug)}
            onClick={onItemClick}
          />
        </li>
      ))}
    </ul>
  );
};

export default SearchResults;
